// import AssistivLogo from '@/assets/branding/assistiv/assistiv-logo.png';
import AllIsWellLogo from '@/assets/branding/alliswell/All-is-Well.png';

const colors = {
  // Brand colors
  brand_primary: '#662D91',
  brand_primary_hover: '#56247E', // −10 L, −8 S
  brand_primary_highlight: '#A381BD', // +23 L, +7 S
  brand_primary_mid: '#7A3CAA', // +8 L,  +2 S
  brand_primary_dark: '#2E1045', // −25 L, −3 S (clamped)
  brand_secondary: '#3B2055', // hue +4°, −15 L, −13 S
  brand_accent_start: '#7a3caa',
  brand_accent_end: '#4F63D6',
  brand_accent_light_start: '#f2e8fa',
  brand_accent_light_end: '#E2E8FF',
  brand_complementary_accent: 'rgb(101,191,34)',
  brand_auth_gradient_mid: '#3B2055',
  brand_auth_gradient_end: '#2E1045',
  brand_auth_warp_mid: '#7A3CAA',
};

export default {
  name: 'All is Well',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AllIsWellLogo,
  colors,
};
